import IconSvg from "../IconSvg/IconSvg";
import {formatDateTime} from "../../utils";
import {Link} from "react-router-dom";
import {deleteNoti, readMarkNotiById} from "../../network/notiApi";
import {fetchCountNoti, fetchNotification} from "../../services/notiServices";
import {clsx} from "clsx";

export const NotificationItemDialog = ({notification, onClick}) => {
  const {title, createdAt, message, isRead, actionUrl, notificationType} = notification || {};
  const {day, time} = formatDateTime(createdAt);
  return (
    <Link to={actionUrl}>
      <div
        className={`flex px-2.5 py-3.5 border-y border-dashed border-grey gap-2.5
         ${isRead ? "bg-white" : "bg-subYellow6"}
         hover:bg-grey cursor-pointer`}
        onClick={onClick}
      >
        <IconSvg iconName={notificationType} color="#111827" size={40}/>
        <div className="flex flex-col w-96 gap-2.5">
          <div className="flex flex-col items-start">
            <div className="text-black text-sm font-normal">{title}</div>
            <div className="text-darkGery text-xs">{`${time} - ${day}`}</div>
          </div>

          <div className="text-darkGrey text-sm text-left">{message}</div>
        </div>
      </div>
    </Link>
  );
};

export const NotificationItemHome = ({notification}) => {
  const {title, createdAt, notificationType, actionUrl} = notification || {};
  const {day, time} = formatDateTime(createdAt);
  return (
    <Link to={actionUrl}
          className={`flex px-2.5 py-3.5 gap-2.5 hover:bg-grey cursor-pointer`}
    >
      <IconSvg iconName={notificationType} color="#111827" size={25}/>
      <div className="flex flex-col w-72 md:w-96 gap-2.5">
        <div className="flex flex-col items-start">
          <div className="text-black text-sm font-normal">{title}</div>
          <div className="text-darkGery text-xs">{`${time} - ${day}`}</div>
        </div>
      </div>
    </Link>
  );
};

export const NotificationItemBrowser = ({notification}) => {
  const {title, createdAt, message, isRead, actionUrl, notificationType, id} = notification || {}
  const {day, time} = formatDateTime(createdAt);
  const handleAction = ({id, type, isRead}) => {
    if (type === 'read') return readMarkNotiById(id).then(res => {
      if (res.success) {
        fetchNotification({
          page: 1,
          size: 5,
          type: 'seller_order'
        })
        fetchCountNoti({
          type: 'seller_order'
        })
      }
    })
    if (type === 'delete') return deleteNoti(id).then(res => {
      if (res.success) {
        fetchNotification({
          page: 1,
          size: 5,
          type: 'seller_order'
        })
        if (!isRead) {
          fetchCountNoti({
            type: 'seller_order'
          })
        }
      }
    })
  }
  const handleClickOnDetail = () => {
    readMarkNotiById(id).then(res => {
      if (res.success) window.location.assign(actionUrl)
    })
  }
  return (
    <div
      className={`w-full flex justify-between gap-2.5 px-2.5 py-4 border-y border-dashed border-gray bg-white ${
        isRead ? "bg-gray-100" : "bg-yellow-50"
      } hover:bg-gray-200`}
    >
      <IconSvg iconName={notificationType} color="#111827" size={40} className="mr-4"/>
      <div className="w-[580px] flex flex-col items-start gap-2.5 font-normal line-height-normal">
        <div className="flex flex-col items-start">
          <div className="text-black text-sm">{title}</div>
          <div className="text-darkGrey text-xs">{`${time} - ${day}`}</div>
        </div>
        <div className="text-darkGrey text-sm text-left">{message}</div>
        <div onClick={handleClickOnDetail} className="text-[#197D55] text-sm text-left cursor-pointer">
          Xem chi tiết
        </div>
      </div>
      <div
        className="flex justify-between items-center gap-3 p-4 text-xs text-black font-normal line-height-normal cursor-pointer">
        <div className={clsx(
          isRead ? "cursor-not-allowed opacity-50" : "hover:text-mainGreen"
        )} onClick={() => !isRead && handleAction({id, type: 'read', isRead})}>Đánh dấu đã đọc
        </div>
        <div>|</div>
        <div className="hover:text-red" onClick={() => handleAction({id, type: 'delete', isRead})}>xóa</div>
      </div>
    </div>
  );
};

export const NotificationItemMobile = ({notification, togglePopupAction}) => {
  const {title, createdAt, message, isRead, actionUrl, notificationType, id} = notification || {};
  const {day, time} = formatDateTime(createdAt);
  return (
    <div className="rounded-xl">
      <div
        className={`flex justify-between gap-2.5 px-2.5 py-4 border-t border-dashed border-gray bg-white ${
          isRead ? "bg-gray-100" : "bg-yellow-50"
        }`}
      >
        <IconSvg iconName={notificationType} color="#111827" size={24}/>
        <Link to={actionUrl}
              className="w-64 flex flex-col items-start text-left gap-2.5 font-normal line-height-normal">
          <div className="text-black text-sm">{title}</div>
          <div className="text-darkGrey text-sm">{message}</div>
          <div className="text-darkGrey text-xs">{`${time} - ${day}`}</div>
        </Link>
        <div className="flex flex-col items-center gap-6 cursor-pointer">
          <div onClick={() => togglePopupAction(id)}>
            <IconSvg iconName="dots-horizontal" color="#111827" size={24}/>
          </div>
          <div>
            {!isRead ? (
              <IconSvg iconName="warming-1" color="#111827" size={9}/>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
